module.exports = __webpack_public_path__ + "img/serverError.5b6d1be6.svg";